export default __webpack_public_path__ + "src/assets/deploy-contracts.f015d8b4522444a636f2934c1ce43937.svg";